import { CompanyListPage } from "@/features/company/pages/CompanyList";
import { CompanySettingColumnProvider } from "@/features/company/providers/CompanySettingColumnProvider";

const CompanyList = () => {
  return (
    <CompanySettingColumnProvider>
      <CompanyListPage />
    </CompanySettingColumnProvider>
  );
};

export default CompanyList;
